import { render, staticRenderFns } from "./EditFlexPropsSchema.vue?vue&type=template&id=25795982&"
import script from "./EditFlexPropsSchema.vue?vue&type=script&lang=js&"
export * from "./EditFlexPropsSchema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports